module.exports = __webpack_public_path__ + "img/tentative_blue.af4736a1.png";